import { render, staticRenderFns } from "./CardHub.vue?vue&type=template&id=3c75271b&scoped=true"
import script from "./CardHub.vue?vue&type=script&lang=js"
export * from "./CardHub.vue?vue&type=script&lang=js"
import style0 from "./CardHub.vue?vue&type=style&index=0&id=3c75271b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c75271b",
  null
  
)

export default component.exports